import { ColumnCenter } from "style/preset"
import StyledContainer from "style/styledContainer"
import styled from "styled-components"

import WarnWalletImg from 'assets/images/warn_wallet_connect.png'

const EmptyWalletCom  = () => {
    return <EmptyWalletWrap>
        <ImgBoxWrap src={WarnWalletImg}></ImgBoxWrap>
        <WarnInfoWrap $mt="20px">Connect a wallet to see your inscriptions</WarnInfoWrap>
    </EmptyWalletWrap>
}

const EmptyWalletWrap = styled(ColumnCenter)``
const ImgBoxWrap = styled.img`
    height: 140px;
`

const WarnInfoWrap = styled(StyledContainer)`
    font-size: 14px;
    font-weight: 500;
    line-height: 14px;
    padding: 6px 8px;
    border-radius: 4px;
    background-color: #F2F2F2;
`

export default EmptyWalletCom